import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./Fixtures.module.css";
import AOS from "aos";
import "aos/dist/aos.css";
import vsImage from "../../assets/images/vs.png";
import Timer from "../Timer/Timer";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import demo2 from "../../assets/images/download (1).jpeg";
import Skeleton from "../Skeleton/Skeleton";

const Fixtures = () => {
  const data = useSelector((state) => state.home.data);
  const pending = useSelector((state) => state.home.pending);
  const error = useSelector((state) => state.home.error);
  const finalData = data.data;
  const [firstRender, setfirstRender] = useState(true);

  var settings = {
    // dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 500,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },

      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    if (firstRender && !pending) {
      setfirstRender(false);
    }
  }, [pending]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      {pending && firstRender ? (
        <div className={styles.loader}>
          <Skeleton type="fixtures" />
        </div>
      ) : (
        !firstRender && (
          <div className={styles.parentContainer}>

            <div className={styles.mainContainer}>
              <Slider {...settings} className={styles.mainSliderContainer}>
                {finalData?.map((item, index) => (
                  // <Skeleton type = 'feed'/>
                  
                  <Link
                    to={`/live-score/match/${item.match_id}/${item.match_status}`}
                  >
                    <div className={styles.slide} key={index}>
                      <>
                        <div className={styles.matchData}>
                          <div className={styles.firstContainer}>
                            <div className={styles.matchInfo}>
                              <p className={styles.teamsName}>
                                {item.team_a} vs {item.team_b}{" "}
                              </p>
                              <p className={styles.seriesName}>{item.series}</p>
                            </div>

                            <p className={item.match_status.toLowerCase() ===
                                      "live"  ? styles.matchStatusLive : styles.matchStatus  }>
                               {item.match_status.toLowerCase() ===
                                      "live"  ? (<div className={styles.liveStatus}><div className={styles.liveRedDot}></div>{item.match_status}</div>) : (<div>{item.match_status}</div>)}
                            </p>
                          </div>

                          <div className={styles.secondContainer}>
                            {(() => {
                              switch (item.match_status.toLowerCase()) {
                                case "live":
                                  return (
                                    <p className={styles.toss}>
                                      {item.toss ? item.toss : ""}
                                    </p>
                                  );
                                case "finished":
                                  return (
                                    <p className={styles.toss}>
                                      {item.result ? item.result : ""}
                                    </p>
                                  );
                                case "upcoming":
                                  return (
                                    <div className={styles.startTime}>
                                      <p>STARTS IN</p>
                                      <Timer
                                        timeValue={item.date_time}
                                        key={index}
                                      />
                                    </div>
                                  );
                                default:
                                  return null;
                              }
                            })()}
                          </div>
                          <div className={styles.thirdContainer}>
                            <div className={styles.teamDetails}>
                              <div className={styles.teamLogo}>
                                <img
                                  src={`https://images.weserv.nl/?url=${item.team_a_img}`}
                                  alt={item.team_a_short}
                                />
                              </div>
                              <div className={styles.teamShortName}>
                                {item.team_a_short}
                              </div>
                              <div className={styles.teamScore}>
                                <p
                                  className={
                                    item.match_status.toLowerCase() ===
                                      "live" ||
                                    item.match_status.toLowerCase() ===
                                      "finished"
                                      ? styles.active
                                      : styles.inactive
                                  }
                                >
                                  {item.team_a_scores_over.length === 0
                                    ? "-"
                                    : item.team_a_scores_over[1]? item.team_a_scores_over[1].score : item?.team_a_scores_over[0]?.score }
                                </p>

                                <p
                                  className={
                                    item.match_status.toLowerCase() ===
                                      "live" ||
                                    item.match_status.toLowerCase() ===
                                      "finished"
                                      ? styles.active
                                      : styles.inactive
                                  }
                                >
                                  {item.team_a_scores_over.length === 0
                                    ? "yet to bat"
                                    : item.team_a_scores_over[1]? item.team_a_scores_over[1].over + " over" : item?.team_a_scores_over[0]?.over + " over"}
                                </p>

                                {/* <LiveScore match_id = {item.match_id} team = {"team_A"} /> */}
                              </div>
                            </div>
                            <div className={styles.vsImage}>
                              <img src={vsImage} alt="" />
                            </div>
                            <div className={styles.teamDetails}>
                              <div className={styles.teamLogo}>
                                <img
                                  src={`https://images.weserv.nl/?url=${item.team_b_img}`}
                                  alt={item.team_b_short}
                                />
                              </div>
                              <div className={styles.teamShortName}>
                                {item.team_b_short}
                              </div>
                              <div className={styles.teamScore}>
                                {/* <LiveScore match_id = {item.match_id} team = {"team_B"}/> */}
                                <p
                                  className={
                                    item.match_status.toLowerCase() ===
                                      "live" ||
                                    item.match_status.toLowerCase() ===
                                      "finished"
                                      ? styles.active
                                      : styles.inactive
                                  }
                                >
                                  {item.team_b_scores_over.length === 0
                                    ? "-"
                                    : item.team_b_scores_over[1]? item.team_b_scores_over[1].score : item?.team_b_scores_over[0]?.score}
                                </p>
                                <p
                                  className={
                                    item.match_status.toLowerCase() ===
                                      "live" ||
                                    item.match_status.toLowerCase() ===
                                      "finished"
                                      ? styles.active
                                      : styles.inactive
                                  }
                                >
                                  {item.team_b_scores_over.length === 0
                                    ? "yet to bat"
                                    : item.team_b_scores_over[1]? item.team_b_scores_over[1].over + " over" : item?.team_b_scores_over[0]?.over + " over"}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className={styles.fourthContainer}>
                            <div className={styles.rates}>
                              <p className={styles.ratesfirstTeam}>
                                {item.min_rate}
                              </p>
                              <p className={styles.ratesSecondTeam}>
                                {item.max_rate}
                              </p>
                            </div>
                          </div>
                        </div>
                      </>

                      <Link
                        to={`/series/${item.series_id}`}
                        className={styles.pointsTable}
                      >
                        <div>
                          <p>View Points Table</p>
                        </div>
                      </Link>
                    </div>
                  </Link>
                ))}
              </Slider>
              <div className={styles.allFixturesButton}>
                {/* <Link to='/siteMaintenance'> */}
                {/* <button>VIEW ALL</button> */}
                {/* </Link> */}
              </div>
            </div>
          </div>
        )
      )}
    </>
  );
};

export default Fixtures;
